/** Funções puras dos indicadores de força (A5): formatação, séries do gráfico e seleção do exercício. */
import type { StrengthExerciseStats, StrengthOverview } from "../api/types";

export type ChartMetric = "max_load_kg" | "est_1rm_kg" | "volume_kg";

/** kg em pt-BR/es/en: sem casas quando inteiro, uma casa quando não; milhar separado. */
export function kgText(v: number | null | undefined, locale = "pt-BR"): string {
  if (v === null || v === undefined) return "—";
  const whole = Number.isInteger(v);
  return `${v.toLocaleString(locale, { minimumFractionDigits: whole ? 0 : 1, maximumFractionDigits: 1 })} kg`;
}

/** Pontos do gráfico de um exercício para a métrica escolhida; ignora dias sem valor (ex.: exercício sem carga). */
export function historyPoints(e: StrengthExerciseStats, metric: ChartMetric): { date: string; value: number }[] {
  return e.history.flatMap((h) => {
    const v = h[metric];
    return v === null || v === undefined || (metric === "volume_kg" && v <= 0) ? [] : [{ date: h.date, value: v }];
  });
}

/** Métrica padrão: carga máxima se o exercício tem carga; senão, séries por treino não se aplica (volume). */
export function defaultMetric(e: StrengthExerciseStats): ChartMetric {
  return e.max_load_kg !== null ? "max_load_kg" : "volume_kg";
}

/** Exercício inicialmente selecionado: o mais recente que tenha ao menos 2 pontos de histórico; senão o primeiro. */
export function pickExercise(o: StrengthOverview | null, current: string | null): StrengthExerciseStats | null {
  if (!o || o.exercises.length === 0) return null;
  const keyOf = (e: StrengthExerciseStats) => e.exercise_id ?? `name:${e.name}`;
  const kept = current ? o.exercises.find((e) => keyOf(e) === current) : undefined;
  return kept ?? o.exercises.find((e) => e.history.length >= 2) ?? o.exercises[0];
}

export const exerciseKey = (e: StrengthExerciseStats) => e.exercise_id ?? `name:${e.name}`;

export function hasStrengthData(o: StrengthOverview | null): boolean {
  return !!o && (o.totals.sets_logged > 0 || o.totals.sets_prescribed > 0);
}
